import React, { useEffect, useState } from 'react';
//import { Link, useNavigate } from 'react-router-dom';
//import { FaArrowLeftLong } from "react-icons/fa6";
import { GoTriangleUp } from 'react-icons/go';
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from 'react-icons/io';
import HdfcHistory from '../components/HdfcHistory';
import img1 from '../assets/image 10.png';
import img2 from '../assets/image 11.png';
import img3 from '../assets/image 12.png';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

const CreditCardsMob = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    const [isOpen,setIsOpen] = useState(-1);
    // const navigate = useNavigate();
    // const handleBackClick = () => {
    //     navigate(-1);
    // }

    function handleOpen(val){
        setIsOpen(val);
    }


    return (
    <div className='h-full w-full font-sans mt-20'>
        {/* <div className='flex justify-start items-center'>
            <Link onClick={handleBackClick}>
                <div className='flex w-full justify-center items-center gap-2 my-2 mx-3 cursor-pointer text-black text-md hover:text-pretty'>
                    <FaArrowLeftLong />
                    Back
                </div>
            </Link>
        </div> */}
        <div className='flex flex-col justify-center items-center w-full my-5'>
            <div className='flex flex-col justify-center items-center h-fit w-[95%] bg-blue-100 rounded-lg p-2'>
                <div className='flex flex-col gap-2 justify-center w-full items-center mt-4 mb-2'>
                    <p className='text-primary text-2xl font-semibold'>Credit Cards</p>
                    <div className='flex flex-row justify-center items-center gap-2'>
                        <p className='text-xs text-black font-semibold'>11 Accounts</p>
                        <p className='text-[10px] text-green-500 font-semibold'>10 Active</p>
                        <p className='text-[10px] text-red-500 font-semibold'>00 Closed</p>
                    </div>
                </div>
                <div className='flex flex-row justify-center items-center gap-0.5 mb-4 h-16 w-full'>
                    <div className='w-[16%]  cursor-pointer' text-sm >
                        <div id='scorebar-0' className='bg-red-500 h-3 rounded-l-md' />
                    </div>
                    <div className='w-[8%] cursor-pointer' text-sm >
                        <div id='scorebar-1' className='bg-primary h-3'/>
                    </div>
                    
                    <div className='w-[6%] cursor-pointer' text-sm >
                        <div id='scorebar-2' className='bg-text_color2  h-3' />
                    </div>
                    
                    <div className='w-[6%] cursor-pointer' text-sm >
                        <div id='scorebar-3' className='bg-text_color3 h-3' />
                    </div>

                    <div className='relative w-[6%] cursor-pointer' text-sm  >
                        <div className='bg-text_color4 h-3 rounded-r-md'/>
                        <div className='flex flex-col items-center justify-start absolute top-100 -left-4 text-xs text-gray-500'>
                            <GoTriangleUp className='text-text_color4' />
                            <p className=''> Excellent </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex flex-row justify-center gap-4 items-center w-[95%] my-4'>
                <p className='text-primary text-sm'>Total Credit Card loan Amount</p>
                <p className='text-black text-xl font-semibold'>₹ 22,456</p>
            </div>
            <div className='flex flex-col items-center w-[94%] lg:w-[90%] mb-3'>
                <div className='visible flex justify-around items-center w-full h-14 rounded-t-lg bg-blue-500 bg-opacity-50 mt-2 text-center'> 
                    <p className='text-primary text-sm w-[30%]'>Bank Name</p>
                    <p className='text-primary text-sm w-[30%]'>Open Date</p>
                    <p className='text-primary text-sm w-[30%]'>Age</p>
                </div>
                <div className='visible flex justify-around items-center w-full h-14 text-center bg-blue-100'> 
                    <p className='flex w-[30%] justify-around items-center gap-2'><img src={img1} width={40} alt=''></img>HDFC</p>
                    <p className='w-[30%] text-xs'>28/01/2022</p>
                    <div className='flex justify-end items-center w-[30%]'>
                        <p className='mr-3 text-xs'>2 Years</p>
                        {isOpen===0 ? <IoIosArrowDropupCircle onClick={()=> handleOpen(-1)} className='text-xl text-primary cursor-pointer'/> : <IoIosArrowDropdownCircle onClick={()=> handleOpen(0)} className='text-xl text-primary cursor-pointer'/>}
                    </div>
                </div>
                <div className={`grid w-full transition-smooth will-change-auto duration-300 overflow-hidden ${isOpen===0 ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
                    {<HdfcHistory/>}
                </div>
                <div className='visible flex justify-around items-center w-full h-14 text-center bg-slate-100'> 
                    <p className='flex w-[30%] justify-around items-center gap-2'><img src={img2} width={40} alt=''></img>Canara</p>
                    <p className='w-[30%] text-xs'>28/01/2022</p>
                    <div className='flex justify-end items-center w-[30%] '>
                        <p className='mr-3 text-xs'>2 Years</p>
                        {isOpen===1 ? <IoIosArrowDropupCircle onClick={()=> handleOpen(-1)} className='text-xl text-primary cursor-pointer'/> : <IoIosArrowDropdownCircle onClick={()=> handleOpen(1)} className='text-xl text-primary cursor-pointer'/>}
                    </div>
                </div>
                <div className={`grid w-full transition-smooth will-change-auto duration-300 overflow-hidden ${isOpen===1 ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
                    {<HdfcHistory/>}
                </div>
                <div className='visible flex justify-around items-center w-full h-14 text-center bg-blue-100 rounded-b-lg'> 
                    <p className='flex w-[30%] justify-around items-center gap-2'><img src={img3} width={40} alt=''></img>SBI</p>
                    <p className='w-[30%] text-xs'>28/01/2022</p>
                    <div className='flex justify-end items-center w-[30%] '>
                        <p className='mr-3 text-xs'>2 Years</p>
                        {isOpen===2 ? <IoIosArrowDropupCircle onClick={()=> handleOpen(-1)} className='text-xl text-primary cursor-pointer'/> : <IoIosArrowDropdownCircle onClick={()=> handleOpen(2)} className='text-xl text-primary cursor-pointer'/>}
                    </div>
                </div>
                <div className={`grid w-full transition-smooth will-change-auto duration-300 overflow-hidden ${isOpen===2 ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
                    {<HdfcHistory/>}
                </div>
            </div>
        </div>
        <Footer />
        <p className='sr-only'>KGST</p>
    </div>
    )
}

export default CreditCardsMob